import { ReactNode } from "react";
import Controls from "./Controls";
import Progress, { ProgressIcon } from "./Progress";
import { useTranslation } from "./Localization";
import RoomHeader from "./RoomHeader";
import { useTourMode } from "./TourMode";

type MirrorActivityLayoutProps = {
  instruction?: string;
  step: number;
  backTo: string;
  nextTo: string;
  children: ReactNode;
  progressIcon?: ProgressIcon;
  showProgressIcon?: boolean;
  nextDisabled?: boolean;
  taskKey?: string;
  pageType?: "task" | "game";
  onCheck?: () => void;
  contentClassName?: string;
};

export default function MirrorActivityLayout({
  instruction = "",
  step,
  backTo,
  nextTo,
  children,
  progressIcon = "center",
  showProgressIcon = true,
  nextDisabled = false,
  taskKey,
  pageType = "task",
  onCheck,
  contentClassName = "",
}: MirrorActivityLayoutProps) {
  const { room } = useTranslation();
  const { interactive } = useTourMode();
  const translatedInstruction = taskKey ? room("mirror")?.tasks[taskKey] : undefined;
  return (
    <main className="screen activity mirror-activity">
      <RoomHeader roomId="mirror" />
      <p className="instruction">{translatedInstruction || instruction}</p>
      <div className={`mirror-task-content ${contentClassName}`.trim()}>{children}</div>
      <Progress step={step} total={7} icon={progressIcon} showIcon={showProgressIcon} showDots={pageType === "game" || interactive} />
      <Controls backTo={backTo} nextTo={nextTo} check={Boolean(onCheck) || (pageType === "game" && nextDisabled)} nextDisabled={nextDisabled} onNext={onCheck} />
    </main>
  );
}
